import { AbstractControl, AsyncValidator, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Directive, forwardRef, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { CheckPhoneUseCase, IdInterface } from '../../../core';
import { phoneExists } from './validator';

// noinspection JSAnnotator
@Directive({
    selector: '[phoneExists][formControlName],[phoneExists][formControl],[phoneExists][ngModel]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => PhoneExistsValidatorDirective),
            multi: true,
        },
    ],
})
export class PhoneExistsValidatorDirective implements AsyncValidator, OnInit {
    private validator: AsyncValidatorFn;

    @Input()
    phoneExists = true;

    @Input()
    clientCode: IdInterface = null;

    constructor(private checkPhoneUseCase: CheckPhoneUseCase) {}

    ngOnInit() {
        this.validator = phoneExists(this.phoneExists, this.checkPhoneUseCase, this.clientCode);
    }

    validate(c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        return this.validator(c);
    }
}
